<template>
	<page style="background: #fff;">
		<h1 class="title">{{title}}</h1>
		<p class="date">{{date}}</p>
		<div v-html="content" class="content"></div>
	</page>
</template>

<script>
	export default {
		props: {
			type: String,
			id: String
		},

		data() {
			return {
				title: '',
				date: '',
				content: ''
			}
		},

		mounted() {
			this.request({
				url: '/article/detail',
				data: {
					article_type: this.type,
					id: this.id
				},
				success: data => {
					this.title = data.title;
					this.date = data.create_date;
					this.content = data.content;
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.title {
		margin: .32rem .32rem 0;
        line-height: .8rem;
        font-size: .5rem;
        text-align: center;
	}

	.date {
        line-height: 1rem;
        font-size: .28rem;
        text-align: center;
        color: #999;
	}

	.content {
		padding: .2rem .32rem .4rem ;
		line-height: .5rem;
		font-size: .28rem;
	}
</style>